import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import { AuthAction, AuthState } from "@/components/auth/types";
import { LoginCredentialsDto } from "@/services/apiService/api.types";
import apiService from "@/services/apiService/apiService";
import storageService from "@/services/storageService/storageService";
import { LocalStorageItems } from "@/helpers/constants";
import apiStorageInterface from "@/services/apiStorageInterface";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import { Locale } from "@/plugins/i18n/types";
import store from "@/store";
import { Namespace } from "@/store/types";
import { AlertAction, AlertType } from "@/components/alert/types";

const logIn = async (
  context: ActionContext<AuthState, RootState>,
  logInCredentials: LoginCredentialsDto
): Promise<void> => {
  try {
    await apiService.logIn(logInCredentials).then((token) => {
      storageService.setItem(LocalStorageItems.Token, token, 0);
    });
    await apiStorageInterface.fetchSortedCategories();
    const userInfo = await apiStorageInterface.fetchUserInfo();
    i18n.locale = userInfo.defaultUserLanguage
      ? userInfo.defaultUserLanguage.code
      : Locale.EN;
  } catch (error) {
    switch (error.response.status) {
      case 422:
        await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
          show: true,
          message: "Incorrect username or password",
          alertType: AlertType.Danger
        });
        break;
      case 500:
        await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
          show: true,
          message: "Internal server error",
          alertType: AlertType.Danger
        });
        break;
    }
  }
};

export const actions: ActionTree<AuthState, RootState> &
  Record<AuthAction, Action<AuthState, RootState>> = {
  [AuthAction.logIn]: logIn
};
